"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Margin = void 0;
var Margin;
(function (Margin) {
    Margin["None"] = "u-marg-none";
    Margin["Normal"] = "u-marg";
    Margin["Negative"] = "u-marg-neg";
    Margin["NegativeHalf"] = "u-marg-neg-half";
    Margin["Auto"] = "u-marg-auto";
    Margin["TopBottom"] = "u-marg-top-bottom";
    Margin["TopBottomLarge"] = "u-marg-top-bottom-large";
    Margin["TopBottomNegative"] = "u-marg-top-bottom-neg";
    Margin["TopBottomAuto"] = "u-marg-top-bottom-auto";
    Margin["LeftRight"] = "u-marg-left-right";
    Margin["LeftRightLarge"] = "u-marg-left-right-large";
    Margin["LeftRightNegative"] = "u-marg-left-right-neg";
    Margin["LeftRightAuto"] = "u-marg-left-right-auto";
    Margin["Top"] = "u-marg-top";
    Margin["TopLarge"] = "u-marg-top-large";
    Margin["TopAuto"] = "u-marg-top-auto";
    Margin["Bottom"] = "u-marg-bottom";
    Margin["BottomLarge"] = "u-marg-bottom-large";
    Margin["BottomAuto"] = "u-marg-bottom-auto";
    Margin["Left"] = "u-marg-left";
    Margin["LeftLarge"] = "u-marg-left-large";
    Margin["LeftAuto"] = "u-marg-left-auto";
    Margin["Right"] = "u-marg-right";
    Margin["RightLarge"] = "u-marg-right-large";
    Margin["RightAuto"] = "u-marg-right-auto";
})(Margin = exports.Margin || (exports.Margin = {}));
//# sourceMappingURL=Margin.js.map